import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import ChoppiedSalesAndCommissionReportSpinner from "../reports/Cachet/ChoppiesSalesAndCommissionReport/SalesAndCommissionReportSpinner";

const actions = {
  closeModal,
};

const choppiesSalesAndCommissionReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <ChoppiedSalesAndCommissionReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(choppiesSalesAndCommissionReportSpinnerModal);
